import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/chevron-down.svg'


const _hoisted_1 = { class: "builder-estimator-floorplans-mobile" }
const _hoisted_2 = { class: "section-card" }
const _hoisted_3 = {
  key: 0,
  class: "section-content section-content-floorplan"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mobile-sections" }
const _hoisted_6 = { class: "section-card" }
const _hoisted_7 = {
  key: 0,
  class: "section-content"
}
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "section-card" }
const _hoisted_15 = {
  key: 0,
  class: "section-content"
}
const _hoisted_16 = { class: "features-list" }
const _hoisted_17 = { class: "feature-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "section-header section-header-floorplan",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleSection('floorplan')))
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Floor plan", -1)),
        _createElementVNode("img", {
          class: _normalizeClass(["chevron", { expanded: $setup.expandedSections.floorplan }]),
          src: _imports_0,
          alt: "expand"
        }, null, 2)
      ]),
      _createVNode(_Transition, { name: "expand" }, {
        default: _withCtx(() => [
          ($setup.expandedSections.floorplan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "img-floorplan",
                  src: $props.floorplanUrl,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openImageModal')))
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "section-header",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleSection('floorPlanArea')))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Floor Plan Area", -1)),
          _createElementVNode("img", {
            class: _normalizeClass(["chevron", { expanded: $setup.expandedSections.floorPlanArea }]),
            src: _imports_0,
            alt: "expand"
          }, null, 2)
        ]),
        _createVNode(_Transition, { name: "expand" }, {
          default: _withCtx(() => [
            ($setup.expandedSections.floorPlanArea)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "Area:", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.formatMeters($props.area, false)) + " SQM", 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Width:", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.formatMeters($props.width, false)) + " M", 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Length:", -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatMeters($props.length, false)) + " M", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "section-header",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleSection('features')))
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "Features", -1)),
          _createElementVNode("img", {
            class: _normalizeClass(["chevron", { expanded: $setup.expandedSections.features }]),
            src: _imports_0,
            alt: "expand"
          }, null, 2)
        ]),
        _createVNode(_Transition, { name: "expand" }, {
          default: _withCtx(() => [
            ($setup.expandedSections.features)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.features, (feature) => {
                      return (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(feature), 1))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}